



















import 'vue-height-tween-transition/index.css'
import HeightTween from 'vue-height-tween-transition'
export default

	components: { HeightTween }

	data: -> open: false

